/* PATHOLOGISTS */
export const GET_ACTIVITY_LOG = "GET_ACTIVITY_LOG";
export const GET_ACTIVITY_LOG_SUCCESS = "GET_ACTIVITY_LOG_SUCCESS";
export const GET_ACTIVITY_LOG_FAIL = "GET_ACTIVITY_LOG_FAIL";

export const GET_REG_ADMIN_NOTIFICATION = "GET_REG_ADMIN_NOTIFICATION";
export const GET_REG_ADMIN_NOTIFICATION_SUCCESS = "GET_REG_ADMIN_NOTIFICATION_SUCCESS";
export const GET_REG_ADMIN_NOTIFICATION_FAIL = "GET_REG_ADMIN_NOTIFICATION_FAIL";